import React, { useState } from 'react';
import './QuantityModal.css';

const QuantityModal = ({ isOpen, onClose, onConfirm, product }) => {
  const [quantity, setQuantity] = useState(1);
  const [error, setError] = useState(''); // Estado para manejar el error

  const handleConfirm = () => {
    if (quantity > product.stock) {
      setError(`La cantidad seleccionada excede el stock disponible (${product.stock}).`);
      return;
    }
    onConfirm(quantity);
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    isOpen && (
      <div className="quantity-modal-overlay" onClick={handleOverlayClick}>
        <div className="quantity-modal-content">
          <h2>{`Agregar ${product.name} ${product.description} al carrito`}</h2>
          <div className="product-details">
            <img src={product.image} alt={product.name} className="product-image" />
          </div>
          <p>Introduce la cantidad:</p>
          <input
            type="number"
            value={quantity}
            onChange={(e) => {
              setQuantity(Math.max(1, parseInt(e.target.value, 10)));
              setError(''); // Limpiar error al cambiar cantidad
            }}
            min="1"
            max={product.stock}
            className="quantity-modal-input"
          />
          {error && <p className="error-message">{error}</p>} {/* Mostrar error si existe */}
          <div className="quantity-modal-buttons">
            <button onClick={handleConfirm} className="quantity-confirm-button">Agregar</button>
            <button onClick={onClose} className="quantity-cancel-button">Cancelar</button>
          </div>
        </div>
      </div>
    )
  );
};

export default QuantityModal;

